exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/_wks-ext.js
// module id = 48
// module chunks = 0